import { cn } from "@babybjorn/ui";
import type { FC, PropsWithChildren } from "react";
import Button from "../Button";
import * as s from "./VariantPicker.module.scss";

type VariantPickerProps = PropsWithChildren<{
	colorLabel?: string;
	fabricLabel?: string;
	toyLabel?: string;
	chosenColor?: string;
	chosenFabric?: string;
	chosenToy?: string;
	materialLabel?: string;
	openMaterialModal?: () => void;
	inScroll?: boolean;
}>;

const VariantPicker: FC<VariantPickerProps> = ({
	children,
	colorLabel,
	fabricLabel,
	toyLabel,
	chosenColor,
	chosenFabric,
	chosenToy,
	materialLabel,
	openMaterialModal,
	inScroll,
}) => {
	return (
		<form className={cn(s.container)}>
			<fieldset className={cn(s.fieldSet, { [s.notInScrollbar]: !inScroll })}>
				{children}
			</fieldset>

			{chosenColor && (
				<div className={cn(s.labelContainer)}>
					<label>{colorLabel}:</label>
					<span>{chosenColor}</span>
				</div>
			)}
			{chosenFabric && (
				<div className={cn(s.labelContainer)}>
					<label>{fabricLabel}:</label>
					{openMaterialModal && (
						<Button
							buttonType="icon"
							variant="container"
							icon="question"
							iconSize={20}
							className={s.question}
							onClick={openMaterialModal}
							aria-label={materialLabel}
						/>
					)}
					<span>{chosenFabric}</span>
				</div>
			)}
			{chosenToy && (
				<div className={cn(s.labelContainer)}>
					<label>{toyLabel}:</label>
					<span>{chosenToy}</span>
				</div>
			)}
		</form>
	);
};

export default VariantPicker;
